'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UriRecognizer = function () {
  function UriRecognizer() {
    _classCallCheck(this, UriRecognizer);

    this.top = { children: [], handlers: [] };
    this.anyHandlers = [];
  }

  UriRecognizer.prototype.add = function add(uri, handler) {
    if (typeof uri !== 'string') throw '`uri` should be string';

    if (typeof handler !== 'function') throw '`handler` should be function';

    if (uri === '*') {
      this.anyHandlers.push(handler);
      return;
    }
    var node = this.top;
    var splited = uri.split('/');

    var _loop = function _loop() {
      if (_isArray) {
        if (_i >= _iterator.length) return 'break';
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) return 'break';
        _ref = _i.value;
      }

      var p = _ref;

      if (p.startsWith(':')) {
        (function () {
          var param = p.slice(1);
          var n = node.children.find(function (n) {
            return n.param === param;
          });
          if (!n) {
            n = { param: param, path: false, handlers: [], children: [] };
            node.children.push(n);
          }
          node = n;
        })();
      } else if (p.startsWith('*')) {
        (function () {
          var param = p.slice(1);
          var n = node.children.find(function (n) {
            return n.param === param;
          });
          if (!n) {
            n = { param: param, path: true, handlers: [], children: [] };
            node.children.push(n);
          }
          node = n;
        })();
      } else {
        var _n = node.children.find(function (n) {
          return n.name === p;
        });
        if (!_n) {
          _n = { name: p, handlers: [], children: [] };
          node.children.push(_n);
        }
        node = _n;
      }

      node.handlers.push(handler);
      if (node.path) {
        return 'break';
      }
    };

    for (var _iterator = splited, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      var _ret = _loop();

      if (_ret === 'break') break;
    }
  };

  UriRecognizer.prototype.recognize = function recognize(uri) {
    if (typeof uri !== 'string') throw '`uri` should be string';

    var result = [];
    var splited = uri.split('/');
    var explorer = [{ params: {}, node: this.top }];

    var _loop2 = function _loop2() {
      if (_isArray2) {
        if (_i2 >= _iterator2.length) return 'break';
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) return 'break';
        _ref2 = _i2.value;
      }

      var p = _ref2;

      explorer = explorer.map(function (e) {
        return e.node.children.filter(function (n) {
          return n.param || n.name === p;
        }).map(function (n) {
          var params = Object.assign({}, e.params);
          if (n.param) {
            params[n.param] = n.path ? splited.splice(splited.indexOf(p)).join('/') : p;
          }
          if (n.path) {
            for (var _iterator6 = n.handlers, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
              var _ref6;

              if (_isArray6) {
                if (_i6 >= _iterator6.length) break;
                _ref6 = _iterator6[_i6++];
              } else {
                _i6 = _iterator6.next();
                if (_i6.done) break;
                _ref6 = _i6.value;
              }

              var _handler2 = _ref6;

              result.push({ uri: uri, params: params, handler: _handler2 });
            }return null;
          }
          return {
            params: params,
            node: n
          };
        }).filter(function (_) {
          return _ != null;
        });
      }).reduce(function (a, b) {
        return a.concat(b);
      }, []);
    };

    for (var _iterator2 = splited, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      var _ret4 = _loop2();

      if (_ret4 === 'break') break;
    }
    for (var _iterator3 = explorer, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var e = _ref3;

      for (var _iterator5 = e.node.handlers, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray5) {
          if (_i5 >= _iterator5.length) break;
          _ref5 = _iterator5[_i5++];
        } else {
          _i5 = _iterator5.next();
          if (_i5.done) break;
          _ref5 = _i5.value;
        }

        var handler = _ref5;

        result.push({ uri: uri, params: e.params, handler: handler });
      }
    }
    result.push;
    for (var _iterator4 = this.anyHandlers, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var _handler = _ref4;

      result.push({ uri: uri, params: {}, handler: _handler });
    }

    return result;
  };

  return UriRecognizer;
}();

exports['default'] = UriRecognizer;


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/uri-recognizer.js
 ** module id = 118
 ** module chunks = 0
 **/